import { Box, Tag, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import {
  FinanceValueObjectsJournalDraftEntryStatusEnum,
  FinanceValueObjectsJournalEntryStatusEnum,
} from 'generated/resources/graphql'

import { mapStatusColor, mapStatusName, mapTooltipLabel } from 'modules/finance/lib/journalEntries'

export const Status: React.FC<{
  status?:
    | FinanceValueObjectsJournalDraftEntryStatusEnum
    | FinanceValueObjectsJournalEntryStatusEnum
}> = ({ status }) => {
  const [open, toggle] = useToggle()
  return (
    <Box flexDirection="row" alignItems="center" gap="s8">
      <Tooltip.Alt
        attachment="bottom center"
        open={open}
        toggle={toggle}
        label={mapTooltipLabel(status)}
      >
        <Tag type={mapStatusColor(status)}>{mapStatusName(status)}</Tag>
      </Tooltip.Alt>
    </Box>
  )
}
